export * from './src/devcenter-app-instance-v1-app-instance-app-instances.universal.js';
